import { render } from "./ReportsForm.vue?vue&type=template&id=8d6cb6a8&ts=true"
import script from "./ReportsForm.vue?vue&type=script&lang=ts"
export * from "./ReportsForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__